import type { FaireProductEntity } from "../../entity_types/product";

export const p_3fk65tf5: FaireProductEntity = {
  token: "p_3fk65tf5",
  type: "product",
  name: "Los Angeles - 7.2 oz Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/11ce7d15f27a936d4a1c9003762d7e72337286c06e3bc67f81ad027c59515a44.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ecee360f6a08354ac5709d2854a9f62437a0b9046cab982d6e4281e9a2c235e2.jpeg",
    "https://cdn.faire.com/fastly/b44edfea0142f392ee5ba142b571ac544b183f0bc0b93bce34b2f3f59545a4a7.jpeg",
    "https://cdn.faire.com/fastly/6a98c1cf4b27ad87d6aee57486e99d674585d7257e69dae2c174547fdef75d7e.jpeg",
    "https://cdn.faire.com/fastly/c759dda0d044a80b01fbeb2139253697c54d28a43f969447ee72db520a9d08ea.jpeg",
    "https://cdn.faire.com/fastly/c92432806d41e3d6f3c618531fde5312106f715a6cf03bbac99e6996e1de4217.jpeg",
  ],
  priceDollars: 11,
  description:
    "Overgrown bougainvillea, canyon hiking, epic sunsets, city lights. Notes of redwood, lime, jasmine, and yarrow.\n\nThis is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\n Our best-selling 7.2 oz Standard Size.This is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\nHand-poured into apothecary inspired amber jars with our signature kraft label and a brass lid. Our candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 40-50 hours.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:48.347Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
